import { render } from "./ResultsGridnew.vue?vue&type=template&id=32643eda&scoped=true"
import script from "./ResultsGridnew.vue?vue&type=script&lang=js"
export * from "./ResultsGridnew.vue?vue&type=script&lang=js"

import "./ResultsGridnew.vue?vue&type=style&index=0&id=32643eda&lang=scss"
import "./ResultsGridnew.vue?vue&type=style&index=1&id=32643eda&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2874961510/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32643eda"]])

export default __exports__